import { render } from "./Edit.vue?vue&type=template&id=0daff7a8"
import script from "./Edit.vue?vue&type=script&lang=js"
export * from "./Edit.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "0daff7a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0daff7a8', script)) {
    api.reload('0daff7a8', script)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=0daff7a8", () => {
    api.rerender('0daff7a8', render)
  })

}

script.__file = "resources/js/Pages/Tour/Edit.vue"

export default script